var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import { Svg } from './Svg';
var CheckRoundSolidIcon = function (props) { return (React.createElement(Svg, __assign({}, props),
    React.createElement("g", null,
        React.createElement("path", { d: "M12,1.33382194e-15 C5.372583,9.28009691e-16 8.11624501e-16,5.372583 0,12 C-8.11624501e-16,18.627417 5.372583,24 12,24 C18.627417,24 24,18.627417 24,12 C23.9922852,5.37578119 18.6242188,0.0077147623 12,1.33382194e-15 Z M18.927,8.2 L12.082,17.489 C11.9187536,17.7055896 11.6753283,17.8475051 11.4064219,17.8828578 C11.1375155,17.9182105 10.8656811,17.8440355 10.652,17.677 L5.764,13.769 C5.33266561,13.423822 5.26282203,12.7943344 5.608,12.363 C5.95317797,11.9316656 6.58266561,11.861822 7.014,12.207 L11.09,15.468 L17.317,7.017 C17.521192,6.71059002 17.8772511,6.54118265 18.2438115,6.57603752 C18.610372,6.61089239 18.9281223,6.84436978 19.0709064,7.18377241 C19.2136904,7.52317505 19.158405,7.91358568 18.927,8.2 Z" })))); };
export var CheckRoundSolid = styled(CheckRoundSolidIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
//# sourceMappingURL=CheckRoundSolid.js.map